import { render } from "./HeadTip.vue?vue&type=template&id=0e25a1fa&scoped=true&ts=true"
import script from "./HeadTip.vue?vue&type=script&lang=ts"
export * from "./HeadTip.vue?vue&type=script&lang=ts"

import "./HeadTip.vue?vue&type=style&index=0&id=0e25a1fa&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e25a1fa"]])

export default __exports__